module.exports = __WEBPACK_EXTERNAL_MODULE_500__;


//////////////////
// WEBPACK FOOTER
// external "gemini/lib/@waca/core-client/js/core-client/ui/core/View"
// module id = 500
// module chunks = 1